import SaurabhImg from '../../images/saurabh.jpg'
import AbhishekImg from '../../images/photo.jpg'
import AbhayImg from '../../images/pp.jpg'
import SiddharthImg from '../../images/Siddharth_image.jpeg'
import AnantImg from '../../images/IMG-20220430-WA0008.jpg'
const people = [
  {
    id: 1,
    image: SaurabhImg,
    name: 'Saurabh Kumar',
    title: 'office manager',
    quote:
      'Fingerstache umami squid, kinfolk subway tile selvage tumblr man braid viral kombucha gentrify fanny pack raclette pok pok mustache.',
  },
  {
    id: 2,
    image:AnantImg,
    name: 'Anant Chaturvedi',
    title: 'Regular Guy',
    quote:
      'Gastropub sustainable tousled prism occupy. Viral XOXO roof party brunch actually, chambray listicle microdosing put a bird on it paleo subway tile squid umami.',
  },
  {
    id: 3,
    image:AbhishekImg,
    name: 'Abhishek Singh',
    title: 'product designer',
    quote:
      'Drinking vinegar polaroid street art echo park, actually semiotics next level butcher master cleanse hammock flexitarian ethical paleo.',
  },
  {
    id: 4,
    image:AbhayImg,
    name: 'Abhay Pratap Singh',
    title: 'the boss',
    quote:
      'Marfa af yr 3 wolf moon kogi, readymade distillery asymmetrical seitan kale chips fingerstache cloud bread mustache twee messenger bag. ',
  },
  {
    id: 5,
    image:SiddharthImg,
    name: 'Siddharth Bhardwaj',
    title: 'the boss',
    quote:
      'Marfa af yr 3 wolf moon kogi, readymade distillery asymmetrical seitan kale chips fingerstache cloud bread mustache twee messenger bag. ',
  },
];

export default people;
